import React, { Component } from 'react';
import { connect } from 'react-redux';
import PastBookingsView from './past-bookings-view';
import { getPastBookings } from './past-bookings-actions';

class PastBookings extends Component {

  componentDidMount() {
    this.props.getPastBookings()
  }

  render() {
    return <PastBookingsView {...this.props} />
  }

}

const mapStateToProps = (state) => ({
  auth: state.auth,
  pastBookings: state.pastBookings
});

const mapDispatchToProps = {
  getPastBookings: getPastBookings
};

export default connect(mapStateToProps, mapDispatchToProps)(PastBookings);



// WEBPACK FOOTER //
// ./src/components/past-bookings/past-bookings.js